import React, { useMemo, useState } from 'react';
import ModalShell from '../ui/ModalShell';
import MapaLeaflet from './MapaLeaflet';
import { colorTecnico } from '../../utils/estados';

// "Por dónde fue" (29-oct-2026, Mapa → Día): el día hecho de cada técnico, todo a la vista: desde dónde salió,
// cada visita numerada en el orden en que la cerró (con la hora) y qué se hizo. Tocar una la marca en el mapa.
const hora = (v) => { const m = String(v || '').match(/T?(\d{2}:\d{2})/); return m ? m[1] : null; };

export default function RepetirDiaSheet({ visitas, salidaDe = null, fechaTxt, onCerrar }) {
    const tecnicos = useMemo(() => [...new Map(visitas.map(v => [v.tecnicoId, v.tecnico])).entries()], [visitas]);
    const [tec, setTec] = useState(tecnicos[0]?.[0] ?? null);
    const [sel, setSel] = useState(null);
    const paradas = useMemo(() => visitas.filter(v => v.tecnicoId === tec)
        .sort((a, b) => String(a.completada || '').localeCompare(String(b.completada || ''))), [visitas, tec]);
    const conPos = paradas.filter(v => v.lat != null);
    const color = colorTecnico(tecnicos.find(([id]) => id === tec)?.[1] || '');
    const s = typeof salidaDe === 'function' && paradas[0] ? salidaDe(paradas[0]) : null;
    const inicio = s?.lat != null ? [s] : [];
    const puntos = [...inicio, ...conPos.map(v => ({
        id: v.id, lat: v.lat, lng: v.lng, color, etiqueta: String(paradas.indexOf(v) + 1),
        titulo: `${paradas.indexOf(v) + 1}. ${v.cliente || 'Visita'}${hora(v.completada) ? ` · ${hora(v.completada)}` : ''}`,
    }))];

    return (
        <ModalShell titulo="Por dónde fue" subtitulo={fechaTxt} onCerrar={onCerrar} ancho="md:max-w-3xl">
            <div className="space-y-3">
                {tecnicos.length > 1 && (
                    <div className="flex gap-2 overflow-x-auto">
                        {tecnicos.map(([id, nombre]) => (
                            <button key={id} type="button" onClick={() => { setTec(id); setSel(null); }} aria-pressed={tec === id}
                                className={`h-9 px-3 shrink-0 rounded-xl text-label font-black inline-flex items-center gap-1.5 border-2 ${tec === id ? 'bg-card' : 'border-transparent bg-chip'}`}
                                style={tec === id ? { borderColor: colorTecnico(nombre) } : undefined}>
                                <span className="w-2.5 h-2.5 rounded-full" style={{ background: colorTecnico(nombre) }} />{String(nombre || '').split(' ')[0]}
                            </button>
                        ))}
                    </div>
                )}
                <div className="rounded-2xl overflow-hidden border border-black/[0.06] dark:border-white/[0.06]">
                    <MapaLeaflet puntos={puntos} seleccionado={sel} lineas={[{ coords: [...inicio, ...conPos].map(p => [p.lat, p.lng]), color }]}
                        ajustarKey={`hecho-${tec}`} onClickPunto={p => setSel(p.id)} className="w-full h-[45vh] min-h-[280px]" />
                </div>
                <ol className="space-y-1.5">
                    {s && <li className="flex items-center gap-2.5 px-2.5 text-caption text-muted"><span className="w-7 h-7 rounded-full bg-[#111827] text-white text-label font-black inline-flex items-center justify-center">S</span>{s.titulo}</li>}
                    {paradas.map((v, i) => (
                        <li key={v.id}>
                            <button type="button" onClick={() => setSel(v.id)}
                                className={`w-full flex items-start gap-2.5 p-2.5 rounded-xl text-left border ${sel === v.id ? 'border-brand-red/50 bg-card' : 'border-black/[0.06] dark:border-white/[0.06] bg-card'}`}>
                                <span className="w-7 h-7 shrink-0 rounded-full text-white text-label font-black inline-flex items-center justify-center" style={{ background: color }}>{i + 1}</span>
                                <span className="flex-1 min-w-0">
                                    <span className="block text-body font-black text-ink truncate">{v.cliente || 'Visita'}</span>
                                    <span className="block text-caption text-muted truncate">{[hora(v.completada) && `Cerró ${hora(v.completada)}`, v.titulo, v.lat == null ? 'sin ubicar' : null].filter(Boolean).join(' · ')}</span>
                                </span>
                            </button>
                        </li>
                    ))}
                </ol>
                <p className="text-caption text-muted">En el orden en que se cerró cada visita. La línea es recta: el camino real pudo ser otro.</p>
            </div>
        </ModalShell>
    );
}
